String.prototype.clearPercentSymbol = function() {
  return this.replaceAll('%', '');
};

String.prototype.clearPercentChars = function() {
  return this.clearAllSpaces().clearPercentSymbol();
};

String.prototype.addPercent = function() {
  return this + ' %';
};

String.prototype.replaceDecimalChar = function(r = ',') {
  return this.replaceAll('.', r);
};

String.prototype.percentToInteger = function() {
  return parseInt(this.clearPercentChars());
};

String.prototype.percentToFloat = function() {
  return parseFloat(this.clearPercentChars());
};

Number.prototype.toStringFormat = function() {
  return this.toFixed(2).replaceDecimalChar();
};

Number.prototype.toPercentFormat = function(decimals = 2) {
  return this.toFixed(decimals)
    .replaceDecimalChar()
    .addPercent();
};
